// removed by extract-text-webpack-plugin
module.exports = {"galleryWrapper":"_2zqLWQB7SyGB-6qcMZJPAw","slider":"bdC-6_hLoz7VC4ANOqlBU","image":"_2uJDeXjCz2wghhSHbTAX1I","raw":"_33oMi9ciecD7GWkRbJMZ_g","customPagination":"_3Y0nhAukFA_1MiaXjzh65F","bullet":"_3RUjNvKfl79_YWqD68usbq","active":"_1Rg6bm-JS9ECQRRUswH8Bw","dotsSlider":"_2U9dggIbfK7CWvib0aZ4vc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/components/CellGallery/CellGallery.scss
// module id = 458
// module chunks = 0